// src/services/nonoService.js
import { db } from '../firebase';
import { collection, deleteDoc, doc, getDocs, setDoc, serverTimestamp, writeBatch } from 'firebase/firestore';

const PUZZLES = 'nono-puzzles';

export const fetchNonoPuzzles = async () => {
  const snapshot = await getDocs(collection(db, PUZZLES));
  const map = {};
  snapshot.docs.forEach(d => { map[d.id] = { id: d.id, ...d.data() }; });
  return map;
};

// Grids are { width, height, cells: '0101…' row by row, title }. Replaces the whole doc so a removed warm-up goes too.
export const saveNonoPuzzle = async ({ id, main }) => {
  const puzzle = { id, main };
  await setDoc(doc(db, PUZZLES, id), { ...puzzle, updatedAt: serverTimestamp() });
  return puzzle;
};

export const deleteNonoPuzzle = (id) => deleteDoc(doc(db, PUZZLES, id));

// Moves puzzles to new dates: moves is { oldId: newId }. Each target is written once and the dates left empty are
// deleted, so swaps and whole-calendar shifts end in the same state whatever order the batches commit in.
// Per-puzzle stats subcollections stay behind (fine before launch, as nobody has played yet).
export const moveNonoPuzzles = async (puzzles, moves) => {
  const targets = new Set(Object.values(moves));
  const ops = [];
  Object.entries(moves).forEach(([from, to]) => {
    const { updatedAt, ...rest } = puzzles[from];
    ops.push({ ref: doc(db, PUZZLES, to), data: { ...rest, id: to, updatedAt: serverTimestamp() } });
    if (!targets.has(from)) ops.push({ ref: doc(db, PUZZLES, from) });
  });
  for (let i = 0; i < ops.length; i += 400) {
    const batch = writeBatch(db);
    ops.slice(i, i + 400).forEach(({ ref, data }) => (data ? batch.set(ref, data) : batch.delete(ref)));
    await batch.commit();
  }
  const next = { ...puzzles };
  Object.keys(moves).forEach(from => { if (!targets.has(from)) delete next[from]; });
  Object.entries(moves).forEach(([from, to]) => { next[to] = { ...puzzles[from], id: to }; });
  return next;
};
